module.exports = __webpack_public_path__ + "sflyssofe.7bc246f57e.svg";